import { render } from "./ManchesterPage.vue?vue&type=template&id=43924194&scoped=true"
import script from "./ManchesterPage.vue?vue&type=script&lang=js"
export * from "./ManchesterPage.vue?vue&type=script&lang=js"

import "./ManchesterPage.vue?vue&type=style&index=0&id=43924194&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43924194"]])

export default __exports__